export {ActionName} from '../../bundle/config/action-names';

export enum ListName {
    code = 'code',
    heading = 'heading',
    lists = 'lists',
    math = 'math',
}

export enum ToolbarName {
    markupHidden = 'markupHidden',
    markupMain = 'markupMain',
    wysiwygHidden = 'wysiwygHidden',
    wysiwygMain = 'wysiwygMain',
    wysiwygSelection = 'wysiwygSelection',
    wysiwygSlash = 'wysiwygSlash',
}
